// USPS state → 2-letter abbreviation lookup.
//
// Do NOT compute an abbreviation by slicing the first two characters of the
// state name — that gives the wrong answer for 26 of 50 states. Georgia is GA,
// not GE; Texas is TX, not TE; Missouri is MO, not MI; Tennessee is TN, not
// TE. This table is the single source of truth.
//
// Accepts case-insensitive full names, common short forms, and pass-through
// of already-abbreviated strings (e.g. "GA" → "GA"). Returns "" for unknown
// input so callers can decide how to render a fallback.
export const STATE_ABBR = {
  "alabama": "AL", "alaska": "AK", "arizona": "AZ", "arkansas": "AR",
  "california": "CA", "colorado": "CO", "connecticut": "CT", "delaware": "DE",
  "florida": "FL", "georgia": "GA", "hawaii": "HI", "idaho": "ID",
  "illinois": "IL", "indiana": "IN", "iowa": "IA", "kansas": "KS",
  "kentucky": "KY", "louisiana": "LA", "maine": "ME", "maryland": "MD",
  "massachusetts": "MA", "michigan": "MI", "minnesota": "MN", "mississippi": "MS",
  "missouri": "MO", "montana": "MT", "nebraska": "NE", "nevada": "NV",
  "new hampshire": "NH", "new jersey": "NJ", "new mexico": "NM", "new york": "NY",
  "north carolina": "NC", "north dakota": "ND", "ohio": "OH", "oklahoma": "OK",
  "oregon": "OR", "pennsylvania": "PA", "rhode island": "RI",
  "south carolina": "SC", "south dakota": "SD", "tennessee": "TN", "texas": "TX",
  "utah": "UT", "vermont": "VT", "virginia": "VA", "washington": "WA",
  "west virginia": "WV", "wisconsin": "WI", "wyoming": "WY",
  // Federal district + inhabited territories (sometimes returned by Places)
  "district of columbia": "DC", "washington dc": "DC", "washington d.c.": "DC",
  "puerto rico": "PR", "guam": "GU", "american samoa": "AS",
  "u.s. virgin islands": "VI", "us virgin islands": "VI",
  "northern mariana islands": "MP",
};

// All valid USPS codes — used to pass through already-abbreviated inputs.
const VALID_CODES = new Set(Object.values(STATE_ABBR));

export function toStateAbbr(state) {
  if (!state) return "";
  const s = String(state).trim();
  const upper = s.toUpperCase();
  if (upper.length === 2 && VALID_CODES.has(upper)) return upper;
  return STATE_ABBR[s.toLowerCase()] || "";
}

// Full state names, alphabetical — used by the Campaigns admin + campaign landing pages.
export const US_STATES = Object.keys(STATE_ABBR).map((k) => k.replace(/\b\w/g, (ch) => ch.toUpperCase()).replace(" Of ", " of ")).sort();

// ---- Public coverage pages (/states, /states/:slug). Slugs match backend/state_pages.py (slug_of). ----
export const COVERAGE_STATES = Object.keys(STATE_ABBR)
  .filter((k) => !["washington dc", "washington d.c.", "puerto rico", "guam", "american samoa", "u.s. virgin islands", "us virgin islands", "northern mariana islands"].includes(k))
  .map((k) => k.replace(/\b\w/g, (ch) => ch.toUpperCase()).replace(" Of ", " of "));
export const stateSlug = (state) => (state || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
export const stateFromSlug = (slug) => COVERAGE_STATES.find((s) => stateSlug(s) === (slug || "").toLowerCase()) || null;
export const statePath = (state) => `/states/${stateSlug(state)}`;
export const trialPathFor = (state) => `/login?mode=register&plan=trial${state ? `&state=${encodeURIComponent(state)}` : ""}`;
